export const urls = {
  accessibilityStatement:
    'https://www.mynewsdesk.com/about/terms-and-conditions/accessibility_statement',
};
